import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Button from 'components/UI/Button'
import Icon from 'components/Icon'

import './info-box.pcss'

const InfoBox = ({
    controller,
    initStartExpanded,
    children,
    className,
    shortText,
    paddingless,
    onOpen,
    onClose,
    hideInfoIcon,
    highlight,
}) => {
    const [expandedState, setExpandedState] = useState(initStartExpanded)

    const expanded = controller ? controller.value : expandedState
    const setExpanded = controller ? controller.setValue : setExpandedState

    return (
        <div
            className={classNames(
                'info-box-container',
                { 'info-box-container--paddingless': paddingless },
                { 'info-box-container--open': expanded },
                { 'info-box-container--highlight': expanded && highlight },
                className,
            )}
        >
            <div className="info-box">
                <div className="info-box__short-text-wrapper">
                    <Button
                        className={classNames(
                            'info-box__toggle-button button--tertiary',
                            { 'info-box__toggle-button--open': expanded },
                            { 'info-box__toggle-button--paddingless': paddingless }
                        )}
                        type="button"
                        trackLabel="openInfo"
                        trackName="openInfo"
                        onClick={() => {
                            if (expanded) {
                                setExpanded(false)
                                onClose && onClose()
                            } else {
                                setExpanded(true)
                                onOpen && onOpen()
                            }
                        }}
                    >
                        <span className="info-box__short-text">{shortText}</span>
                        {(!hideInfoIcon && !expanded) && (
                            <Icon name="icon_info_circle" size="m" />
                        )}
                        {expanded && (
                            <Icon name="icon_chevron_up" size="m" />
                        )}
                    </Button>
                </div>
                <div
                    className={classNames(
                        'info-box__full-text',
                        { 'info-box__full-text--closed': !expanded },
                        { 'info-box__full-text--open': expanded },
                    )}
                >
                    <div className="info-box__content">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}

InfoBox.propTypes = {
    controller: PropTypes.shape({
        value: PropTypes.bool.isRequired,
        setValue: PropTypes.func.isRequired,
    }),
    shortText: PropTypes.string.isRequired,
    className: PropTypes.string,
    paddingless: PropTypes.bool,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    hideInfoIcon: PropTypes.bool,
    highlight: PropTypes.bool,
}

export default InfoBox
